
<template>
    <div>
        <topback title="Add Bank Card" path="back"></topback>
        <div class="addpaymentmethod">
            <md-field>
                <bankform :bank="bank" :edit="edit"/>
                <md-field-item solid title="Notice">
                    <p slot="children" style="color: red;">
                        Please ensure that you fill in real personal information. The information you fill in will be used for real transactions. If there is a remittance error caused by incorrect information, will not accept it
                    </p>
                </md-field-item>
            </md-field>
        </div>
    </div>
</template>

<script>
import topback from '@/components/topback'
import bankform from '@/views/my/forms/bankform'
import { editbank, getbanklist } from '@/request/api'


export default {
    name: 'addpaymentmethod',
    components: {
		[topback.name]: topback,
        bankform
    },
    data() {
        return {
            edit: false,
            bank: null,
        }
    },
    created() {
        this.id = this.$route.params.id;
        if(this.id) {
            this.get_bankinfo(this.id);
        }
    },
    methods: {
        get_bankinfo(id) {
            getbanklist({id: id}).then(res=>{
                if(res.code === 200) {
                    this.edit = true;
                    this.bank = res.data;
                } else {
                    this.$toast.failed(res.errmsg);
                }
            })
        }
    }

}

</script>

<style scoped>
.addpaymentmethod {
    margin-top: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/views/my/bankadd.vue